import { useId } from 'react';
import { t } from '../i18n/index.ts';
import { IconButton } from './ui.tsx';

/**
 * Moves a card up or down in its column with a press: what the board also does by dragging, for people who cannot
 * drag (WCAG 2.2, 2.5.7) or use the keyboard.
 */
export function Reorder({ index, count, busy, onMove }: { index: number; count: number; busy?: boolean; onMove: (by: -1 | 1) => void }) {
  const label = useId();
  if (index < 0 || count < 2) return null;
  return (
    <div className="field">
      <span className="field-label" id={label}>
        {t('common.position')}
      </span>
      <div className="row" role="group" aria-labelledby={label} style={{ alignItems: 'center', gap: 8 }}>
        <IconButton icon="arrowUp" label={t('common.move_up')} disabled={busy || index === 0} onClick={() => onMove(-1)} />
        <IconButton icon="arrowDown" label={t('common.move_down')} disabled={busy || index === count - 1} onClick={() => onMove(1)} />
        <span className="muted small" aria-live="polite">
          {t('common.position_of', { n: index + 1, count })}
        </span>
      </div>
    </div>
  );
}

/** The `before` a move action takes to put the item at `index` one place up or down in `ids` (null: last). */
export function beforeFor(ids: readonly string[], index: number, by: -1 | 1): string | null {
  return by === -1 ? ids[index - 1]! : (ids[index + 2] ?? null);
}
